@if (form?.get('accountInformations')?.controls?.investmentGoals?.errors) {
  <info [option]="optionInfo1"> vous devez choisir au moins une option </info>
}

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="checkbox">
        <pr-checkbox-group
          formControlName="investmentGoals"
          [options]="options"
        >
        </pr-checkbox-group>
      </div>
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
@if (isSubmitting) {
  <pr-loader></pr-loader>
}
